import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CampaignService } from 'src/app/_services/campaign.service';
import { EmailIntegrationService } from 'src/app/_services/email-integration.service';
import { LoadingService } from 'src/app/_services/loading.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { EmailCampaignLimitsComponent } from '../email-campaign-limits/email-campaign-limits.component';

@Component({
    selector: 'app-email-campaign-connect',
    templateUrl: './email-campaign-connect.component.html',
    styleUrls: ['./email-campaign-connect.component.scss'],
    standalone: false
})
export class EmailCampaignConnectComponent implements OnInit {
  projectNumber = this.resolveProjectNumberFromUrl();
  @Output() connected = new EventEmitter<void>();

  private resolveProjectNumberFromUrl(): string | undefined {
    const segments = window.location.pathname.split('/').filter(Boolean);
    return segments[0] === 'projects' ? segments[1] : undefined;
  }

  gmailAccountDetails: any;
  outlookAccountDetails: any;
  loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
  displayPage = false;

  /**Tootip message for warning */
  warningMessage: string = "";

  constructor(private router: Router, private emailintegrationservice: EmailIntegrationService, private emailCampaignService: CampaignService, private _localstorageservice: LocalStorageService, private ngbModal: NgbModal) {
  }

  ngOnInit() {
    this.loadn[0].style.display = 'block';
    // this.router.navigate(['/email-campaign/dashboard']);
    this.fetchIntegration()

    // Used to check status of email intergration, implement same as email-integration.component.ts
    window.addEventListener('storage', (event)=> {
      if(event.key == 'gmail_integration' || event.key == 'outlook_integration'){
        if (event.newValue == 'success') {
          // fetchIntegration is handled after the limits modal is closed
        } else {
          if(event.newValue.includes("GOOGLE_INTEGRATION")){
            this.warningMessage = "Someting went wrong"
            setTimeout(() => this.warningMessage = '', 3000);
          } else{
          }
        }
      }
      setTimeout(()=>{
        localStorage.removeItem("gmail_integration");
        localStorage.removeItem("outlook_integration");
      },2000)
    }, false);
  }

  fetchIntegration(){
    this.emailintegrationservice.fetchintegratedemails().subscribe((res:any)=>{
     if(res.status == 'success'){
       if(res.integratedemailsarray && res.integratedemailsarray.length){
        this.gmailAccountDetails = res.integratedemailsarray.filter(x => x.integrationplatform == 'gmail')[0]
        this.outlookAccountDetails = res.integratedemailsarray.filter(x => x.integrationplatform == 'outlook')[0]
        if (this.projectNumber) {
          this.displayPage = true;
          this.loadn[0].style.display = 'none';
          this.connected.emit();
        } else {
          this.getCampaigns({created_by: this._localstorageservice.getItem('userdata').userid});
        }

       }else{
         this.gmailAccountDetails = null
         this.outlookAccountDetails = null
          this.loadn[0].style.display = 'none'
          this.displayPage = true;
       }
     }
    })
  }
  onGmailConnect(event: any) {
    // Handle the event emitted by the Gmail button
    if (event.success) {
      // Show limits modal first, then navigate after user dismisses it
      this.showLimitsAcknowledgeModal();
    } else {
      // Connection error
      console.error('Error connecting to Gmail:', event.error);
    }
  }
  onOutlookConnect(event: any) {
    // Handle the event emitted by the Gmail button
    if (event.success) {
      // Show limits modal first, then navigate after user dismisses it
      this.showLimitsAcknowledgeModal();
    } else {
      // Connection error
      console.error('Error connecting to outlook:', event.error);
    }
  }

  private showLimitsAcknowledgeModal(): void {
    const ref = this.ngbModal.open(EmailCampaignLimitsComponent, { backdrop: 'static', centered: true, size: 'lg' });
    ref.componentInstance.mode = 'acknowledge';
    // Navigate only after user closes the modal
    ref.result.then(
      () => this.fetchIntegration(),
      () => this.fetchIntegration()
    );
  }

  getCampaigns(data: {}) {
    // const tempData = this.campaigns;
    // this.displayCampaigns = tempData.slice(this.startIndex, this.endIndex);
    this.emailCampaignService.getCampaigns(data).subscribe(
      (data: any[]) => {
        if(data['total']){
          this.router.navigate(['/email-campaign/campaign-listing']);
        }
        else{
          this.router.navigate(['/email-campaign/dashboard']);
        }
        // this.totalCount = ???
          this.displayPage = true;
          this.loadn[0].style.display = 'none'
      },
      error => {
        console.error('Error getting campaigns:', error);
          this.displayPage = true;
          this.loadn[0].style.display = 'none'
        }

        );

  }

}
